import React from 'react'
import { Link } from 'gatsby'
import { motion } from 'framer-motion'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'

import './mega_menu.scss'

const variantBox = {
  hidden: { opacity: 0, top: -100 },
  show: { opacity: 1, top: 0 }
}

const variantMenuAnimate = {
  enter: {
    opacity: 1,
    rotateX: 0,
    transition: {
      duration: 0.3
    },
    display: 'block'
  },
  exit: {
    opacity: 0,
    rotateX: -15,
    transition: {
      duration: 0.3,
      delay: 0
    },
    transitionEnd: {
      display: 'none'
    }
  }
}

const MobileMegaMenu = ({ items }) => {
  return (
    <motion.ul>
      {items.map((item, index) => {
        return (
          <motion.li
            key={index}
            variants={variantBox}
            initial="hidden"
            animate="show"
            exit="hidden">
            <Link to={item.href}>
              <label>{item.label} <FontAwesomeIcon icon={faArrowRight} /></label>
              <span>{item.description}</span>
            </Link>
          </motion.li>
        )
      })}
    </motion.ul>
  )
}

export default ({ open, items, children }) => {
  return (
    <motion.div
      className="menu-container">
      {children}

      <motion.div
        key="mega-menu-motion"
        className="mega-menu mobile mb-2"
        initial="exit"
        animate={open ? "enter" : "exit"}
        variants={variantMenuAnimate}>
        {items && (
          <MobileMegaMenu items={items} />
        )}
      </motion.div>
    </motion.div>
  )
}
